import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import { config } from '@/config'
import message from './message.js' 


/* eslint-disable */

Vue.use(Vuex)

const setLocalstorage = (name, value) => {
	localStorage.setItem(name, JSON.stringify(value))
}

const getLocalstorage = (name) => JSON.parse(localStorage.getItem(name))



export default new Vuex.Store({
	state: {
		dashboard: null,
		buttons: [
			{
				'id': 'hosts',
				'active': getLocalstorage('btn-hosts') != null ? getLocalstorage('btn-hosts') : true,
				'caption': {
					'active': 'Фильтр хостов',
					'inactive': 'Все хосты'
				},
				'action': 'useFilter'
			},

			{
				'id': 'problems',
				'active': getLocalstorage('btn-problems') != null ? getLocalstorage('btn-problems') : false,
				'caption': {
					'active': 'Все проблемы',
					'inactive': 'Нерешенные'
				},
				'action': 'showSolved'
			}

		],

		busy: false,
		auth: localStorage.getItem('sid') || sessionStorage.getItem('sid') || null,
		refreshID: null
	},
	getters: {
		displayButtons(state) {
			return state.buttons.map(button => {
				//console.log('Btn ', button.id, ' - ', (localStorage.getItem('btn-' + button.id) != 'null'))
				return {
					'id': button.id,
					'active': button.active,
					//'active' : localStorage.getItem('btn-' + button.id) != 'null' ?  localStorage.getItem('btn-' + button.id) : button.active,
					'caption': button.active ? button.caption.active : button.caption.inactive
				}
			})
		},

		isBusy(state) {
			return state.busy
		}
	},

	mutations: {
		SET_DATA(state, data) {
			//console.log(data)
			state.dashboard = data
		},

		TOGGLE_BUTTON(state, id) {
			let btn = state.buttons.find(btn => btn.id === id)
			btn.active = !btn.active

			//localStorage.setItem('btn-' + btn.id, btn.active)
			setLocalstorage('btn-' + btn.id, btn.active)
		},

		SET_BUSY(state, busy) {
			state.busy = !!busy
		},

		SET_AUTH(state, auth) {
			state.auth = auth
		},

		RESET_AUTH(state) {
			state.auth = null
			localStorage.removeItem('sid')
			sessionStorage.removeItem('sid')
		},

		SET_REFRESHID(state, id) {
			state.refreshID = id
		}
	},
	actions: {
		async fetchData({commit, state}) {
			//console.log('FetchData state.auth', state.auth)
			if (!state.auth)
				return false


			commit('SET_BUSY', true)
			let actions = state.buttons.filter(btn => btn.active).map(btn => btn.action)
			//console.log('Actions: ', actions.join('&'))

			let response = await axios.get(config.APP_URL + '?sid=' + state.auth + (actions ? '&' + actions.join('&') : ''))
			if (response && response.data) {
				
			}


			commit('SET_DATA', response && response.data ? response.data : [])
			commit('SET_BUSY', false)
		},

		async toggleButton({commit,dispatch}, id) {
			commit('TOGGLE_BUTTON', id)
			await dispatch('fetchData')
		},

		async logout({commit, state}) {
			//console.log('Processing logout')
			await axios.get(config.APP_URL + '?logout&sid=' + this.state.auth);
			commit('RESET_AUTH')
		},

		async login({commit}, {login, passwd, remember}) {
			const formData = new FormData();
			formData.append('login', login);
			formData.append('passwd', passwd);

			let response = await axios.post(config.APP_URL + '?auth', formData);

			if (response && response.data && response.data.success) {
				//console.log('Processing login with sid', response.data.sid)
				const storage = remember ? localStorage : sessionStorage
				storage.setItem('sid', response.data.sid)
				commit('SET_AUTH', response.data.sid)
			}

		},


		startAutoRefresh({commit, state, dispatch}) {
			if (state.refreshID) {
				return false
			}

			//console.log('Starting autorefresh')
			const refreshID = setInterval(() => {
				//console.log('Process reload')
				dispatch('fetchData')
	
			}, 20 * 1000);
			commit('SET_REFRESHID', refreshID)
		},

		stopAutoRefresh({commit, state}) {
			//console.log('Stopping autorefresh')
			if (state.refreshID) {
				clearInterval(state.refreshID)
				commit('SET_REFRESHID', null)
			}
		}
	},


	modules: {
		message
	}
})
